export const continueRegistration = 'continuar-cadastro';
